import React from 'react';
import { useMediaQuery } from '@monofront/business/hooks';
import AccountOutline from '@monofront/design-system/visuals/Icons/Old/AccountOutline';
import { ICustomer } from '@monofront/types';
import { format } from '@monofront/business/utils';
import { useTranslations } from 'next-intl';

interface IUserInfos {
  customer?: ICustomer | null;
}

const UserInfos: React.FC<IUserInfos> = ({ customer }) => {
  const isMobile = useMediaQuery(800);
  const tAccount = useTranslations('Account');

  return (
    <>
      <div className="header user-infos">
        <div className="header-illu">
          <AccountOutline
            width={isMobile ? 32 : 190}
            height={isMobile ? 32 : 190}
          />
        </div>
        <h1 data-cs-mask>
          {customer?.firstName
            ? tAccount('hello', { name: customer?.firstName })
            : tAccount('welcome')}{' '}
          💛
        </h1>
        {customer?.savings ? (
          <p className="savings">
            <span>{tAccount('mySavings')}</span>{' '}
            <span className="amount">{format(customer.savings)}</span>
          </p>
        ) : null}
      </div>
      <style jsx>{`
        .header {
          margin: var(--space-5) 0;
          border: var(--border);
          text-align: center;
          padding: var(--space-8) 0;
          position: relative;
          overflow: hidden;
        }

        .header-illu {
          position: absolute;
          left: 80px;
          top: 0;
          opacity: 0.15;
        }

        .header > h1 {
          font-size: var(--font-size-4);
          margin-bottom: var(--space-1);
        }

        .savings {
          font-size: var(--font-size-3);
        }

        .amount {
          color: var(--clr-tertiary-1);
          font-weight: var(--font-weight-bold);
          font-family: var(--font-family-1);
        }

        @media (max-width: 800px) {
          .header {
            border: none;
            margin: 0;
            padding: var(--space-4) 0 var(--space-3) 0;
          }

          .header-illu {
            left: 0;
            position: relative;
            opacity: 1;
          }

          .header-illu > :global(svg > path) {
            fill: var(--black);
          }

          .header > h1 {
            font-size: var(--font-size-3);
          }

          .savings {
            font-size: var(--font-size-2);
            font-weight: var(--font-weight-base);
          }
        }
      `}</style>
    </>
  );
};

export default UserInfos;
